import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { AdminService } from "../../admin.service";

@Component({
    selector: 'app-edit-quote',
    templateUrl: './edit-quote.component.html',
    styleUrls: ['./edit-quote.component.scss']
  })
  
export class ProcureEditQuoteComponent implements OnInit {

    public quoteForm: FormGroup;
    public moment: any;
    public loginName: string;
    public loginUserId: string;
    public addresses: any;
    public quoteId: number;
    public quoteDetails: any;
    public length: number = 0;

    constructor(
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder, 
        public adminService: AdminService, 
        private toastr: ToastrService,
        public router: Router
    ){

    }

    ngOnInit(): void {
        this.quoteId = parseInt(this.activatedRoute.snapshot.paramMap.get('id'));

        this.moment = moment;
        this.loginName = localStorage.getItem('name');
        this.loginUserId = localStorage.getItem('id');
        this.getProfileDetails();
        this.getQuoteForm();
        this.getQuoteDetails(this.quoteId);
    }

    public getQuoteForm(): void{
        this.quoteForm = this.fb.group({
            'deliverydate': [null],
            'customerid': [this.loginUserId],
            'shippingaddressid': [null],
            'supplierid': [0],
            "quantity": [0],
            "totalcost": [0],
            "taxes": [0],
            "shipingcost": [10],
            "paymentmethodid": [0],
            "paymentstatusid": [0],
            "currencytypeid": [1],
            "contactperson": ["10"],
            "shipmenttermsid": [41],
            "paymenttermsid": [42],
            "loanid": [0],
            "insertype": ["23"],
            "salesrepid": [0],
            'materialsItems': this.fb.array([])
        });
        this.addItemsArray();
    }

    public addItemsArray(){
        for(var i = 0; i < this.length; i++){
            (this.quoteForm.get('materialsItems') as FormArray).push(this.fb.group({
                "id": [null],
                "materialtypeid": [null],
                "mategrialdescription": [null],
                "quantity": [null],
                "targetdate": [null],
                "itemcost": [null],
                "priceperkg": [null]
              }));
        }
    }

    public removeItems(idx): void{
        (this.quoteForm.get('materialsItems') as FormArray).removeAt(idx);
    }

    getQuoteDetails(id): void{
        this.adminService.getQuoteDetails(id).subscribe(
            (res: any) => {
                const data = res.body.data;
                this.quoteDetails = res.body.data;
                this.length = this.quoteDetails.materialsItems.length;
                this.addItemsArray();
                this.quoteForm.patchValue(data);         
            },
            err => {
               console.log(err);
            }
          );
    }

    getProfileDetails(): void {
        this.adminService.getUserProfileDetails().subscribe(
          (res: any) => {
            this.addresses = res.addresses;
          },
          err => {
             console.log(err);
          }
        );
    }

    saveQuote(){
        const quoteRequest = this.quoteForm.getRawValue();
        quoteRequest.customerid = Number(quoteRequest.customerid);
        quoteRequest.shippingaddressid = Number(quoteRequest.shippingaddressid);
        quoteRequest.supplierid = Number(quoteRequest.supplierid);
        quoteRequest.shipingcost = Number(quoteRequest.shipingcost);
        quoteRequest.taxes = Number(quoteRequest.taxes);
        quoteRequest.totalcost = Number(quoteRequest.totalcost);
        quoteRequest.items = quoteRequest.materialsItems;
        let totalQuantity = 0;
        this.quoteForm.getRawValue().materialsItems.forEach((element, i) => {
            totalQuantity += element.quantity;
            quoteRequest.items[i]['itemcost'] = element.quantity * element.priceperkg;
        });
        quoteRequest.quantity = totalQuantity;

        this.adminService.updateQuotes(this.quoteId,quoteRequest).subscribe(
            (res: any) => {
                if( res?.body?.status == 'success' && res?.body?.data?.affected >= 1){
                    this.backQuotePage();
                    this.toastr.success('Successfully created quotes');
                } else {
                    this.toastr.error('Update Failed');
                }
            },
            err => {
               console.log(err);
            }
          );
    }

    backQuotePage(){
      this.router.navigate(['/admin/procure']);
    }

}